// extracted by mini-css-extract-plugin
module.exports = {"triggerWrapper":"Trigger_triggerWrapper__ShPk5"};